enum BreakpointEnum {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  XLarge = 'xl',
  Max = 'xxl',
}

export default BreakpointEnum;
